import common from "../common";

export default class Projectile extends PIXI.Sprite
{
    constructor()
    {
        super(PIXI.Texture.EMPTY);
        
        this.originFighter = null;
        this.hasLeftOriginFighter = false;
        this.hasLeftOriginField = false;
        this.anchor.set(0.5);
        this.imageData = null;
        this.speed = {x:0, y:0};
        this.weight = 1;
        this.damage = 1;
        this.groundLevel = 0;
        this.bounce = 0;
        this.bounceOffWalls = false;
        this.bounceOffFighters = false;
        this.persistentData = null;
        this.isPersistent = false;
        this.incapacitate = false;
        this.shockRadius = null;
        this.particle = null;
        this.setRotation = null;
        this.rotationSpeed = null;
        this.xSpeedMod = null;
        this.flashTint = null;
        this.shake = null;
        this.audio = null;

        this.splatting = false;
        this.canRemove = false;

        this.trajectory = null;

        this.tempGraphic = null;

        this.shadow = common.display.container();
        this.shadow.graphic = common.display.sprite({asset:'food_shadow', alpha:0.5, anchor:0.5, parent:this.shadow});
    
        this.inAirParticle = null;
    }

    init(originFighter, imageData, x, y, speedX, speedY, weight, damage, groundLevel, bounce, bounceOffWalls, bounceOffFighters, persistentData, incapacitate, shockRadius, particle, setRotation, xSpeedMod, flashTint, shake, shadowHolder, audio)
    {
        this.originFighter = originFighter;
        this.hasLeftOriginFighter = false;
        this.hasLeftOriginField = false;
        this.imageData = imageData;
        this.texture = imageData ? P3.assets.texture(imageData.throw) : PIXI.Texture.EMPTY;
        this.x = x;
        this.y = y;
        this.rotation = (typeof setRotation == 'number' ? setRotation : (360 * Math.random())) * PIXI.DEG_TO_RAD;
        this.speed.x = speedX;
        this.speed.y = speedY;
        this.rotationSpeed = speedX;
        this.weight = weight;
        this.damage = damage;
        this.groundLevel = groundLevel;
        this.bounce = bounce;
        this.bounceOffWalls = bounceOffWalls;
        this.bounceOffFighters = bounceOffFighters;
        this.persistentData = persistentData;
        this.incapacitate = incapacitate;
        this.shockRadius = shockRadius;
        this.particle = particle;
        this.setRotation = setRotation;
        this.xSpeedMod = xSpeedMod;
        this.flashTint = parseInt ? parseInt(flashTint, 16) : null;
        this.shake = shake;
        
        shadowHolder.addChild(this.shadow);
        this.shadow.x = this.x;
        this.shadow.y = this.y;
        this.shadow.graphic.scale.set((this.width / this.shadow.graphic.width) * 0.5);

        this.audio = audio;
        
        //this.calculateTrajectory(currentTime);

        this.scale.set(common.config.settings.gamePhysics.projectiles.imageScale * (imageData ? imageData.scale : 1));
    }

    destroy()
    { 
        super.destroy();
    }

    update()
    {
        if(!this.isPersistent && !this.splatting)
        {
            this.speed.y += this.weight * (P3.Ticker.dt * common.timeStretch);
            if(this.xSpeedMod)
            {
                this.speed.x += this.xSpeedMod * (P3.Ticker.dt * common.timeStretch);
            }
            
            this.y += this.speed.y * (P3.Ticker.dt * common.timeStretch);
            this.x += this.speed.x * (P3.Ticker.dt * common.timeStretch);
            if(this.setRotation == null)
            {
                this.rotation += PIXI.DEG_TO_RAD * (this.rotationSpeed * 0.01);
            }

            var p = this;
            var f = this.originFighter;
            var fl = f.field;

            if(!p.hasLeftOriginFighter)
            {
                if(p.x > f.x + f.bounds.x && p.x < f.x + f.bounds.x + f.bounds.width &&
                p.y > f.y + f.bounds.y && p.y < f.y + f.bounds.y + f.bounds.height)
                {}
                else
                {
                    p.hasLeftOriginFighter = true;
                }
            }
            if(!p.hasLeftOriginField)
            {
                if(p.x > fl.x && p.x < fl.x + fl.width)
                {}
                else
                {
                    p.hasLeftOriginField = true;
                }
            }
        }
        
        this.shadow.x = this.x;
        this.shadow.y = this.weight > 0 ? this.groundLevel : this.y + 100;
        var sper = 1-(Math.abs(this.shadow.y - this.y) / 400);
        if(sper > 0.97)
        {
            sper = (sper - 0.97) / 0.3;
        }
        this.shadow.alpha = sper;
        this.shadow.scale.set(sper);

        if(this.flashTint)
        {
            var segment = 0.1 + (0.7 * this.bounce);
            var p = 0.2 + (0.6 * this.bounce);

            //var p = Math.max(0.3, (this.bounce || 1))
            if( this.bounce < 1 && (common.timeElapsed % segment) > (segment * p) )
            {
                this.tint = this.flashTint;
            }
            else
            {
                this.tint = 0xFFFFFF;
            }
        }

        if(this.inAirParticle)
        {
            this.inAirParticle.updateOwnerPos(this.x, this.y);
        }
    }

    reset()
    {
        this.originFighter = null;
        this.hasLeftOriginFighter = false;
        this.hasLeftOriginField = false;
        this.imageData = null;
        this.texture = PIXI.Texture.EMPTY;
        this.x = 0;
        this.y = 0;
        this.scale.set(1);
        this.rotation = 0;
        this.rotationSpeed = 0;
        this.speed.x = 0;
        this.speed.y = 0;
        this.weight = 1;
        this.damage = 0;
        this.groundLevel = 0;
        this.bounce = 0;
        this.bounceOffWalls = false;
        this.bounceOffFighters = false;
        this.persistentData = null;
        this.isPersistent = false;
        this.incapacitate = false;
        this.shockRadius = 0;
        this.particle = null;
        this.setRotation = null;
        this.xSpeedMod = null;
        this.flashTint = null;
        this.shake = null;
        this.tint = 0xFFFFFF;
        this.splatting = false;
        this.canRemove = false;
        if(this.tempGraphic)
        {
            this.removeChild(this.tempGraphic);
            this.tempGraphic = null;
        }
        this.shadow.parent.removeChild(this.shadow);
        this.shadow.graphic.scale.set(1);
        this.audio = null;
        this.trajectory = null;
    }

    bounceUp()
    {
        this.speed.y = -this.speed.y * this.bounce;
        this.bounce = this.bounce / 2;
        if(this.bounce < 0.01) this.bounce = 0;
    }

    setAsPersistent()
    {
        this.isPersistent = true;
        this.y = this.groundLevel;
        if(this.persistentData.images && this.persistentData.images.length > 0)
        {
            var imageData = common.config.weapons.images[this.persistentData.images[Math.floor(Math.random() * this.persistentData.images.length)]];
            if(imageData)
            {
                this.texture = P3.assets.texture(imageData.throw);
                this.scale.set(common.config.settings.gamePhysics.projectiles.imageScale * (imageData ? imageData.scale : 1));
                this.rotation = 0;
            }
        }
        
        if(this.persistentData.incapacitate !== undefined)
        {
            this.incapacitate = this.persistentData.incapacitate;
        }
        if(this.persistentData.damage !== undefined)
        {
            this.damage = this.persistentData.damage;
        }
    }

    splat()
    {
        if(this.splatting) return;

        this.texture = P3.assets.texture(this.imageData.splat);
        this.splatting = true;
        TweenMax.to(this.scale, 0.1, {x:this.scale.x * 1.5, y:this.scale.y * 1.5, ease:Back.easeOut, onComplete:() => {
            this.canRemove = true;
        }});

        if(this.inAirParticle)
        {
            this.inAirParticle.emit = false;
        }
    }

    calculateTrajectory(currentTime)
    {
        this.trajectory = [];

        var delta = 1 / 30;
        var regDelta = 1 / 5;
        var frameCount = 0;
        var x = this.x;
        var y = this.y;
        var speedY = this.speed.y;

        while(y < this.groundLevel)
        {
            speedY += this.weight * delta;
            x += this.speed.x * delta;
            y += speedY * delta;
            frameCount++;
            if(frameCount * delta > this.trajectory.length * regDelta)
            {
                this.trajectory.push({time:currentTime + (frameCount * delta), x:x, y:y});
            }
        }
    }
}